import { Component, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Observable, of, Subject } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

//ng-bootstrap
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

//models
import { DatafieldTypes } from 'src/app/models/database/datafield-type.model';
import { Datafield } from 'src/app/models/database/datafield.model';
import { PermissionsEnum } from 'src/app/enums/permissions.enum';

//services
import { PepService } from 'src/app/services/http/pep/pep.service';
import { PermissionService } from 'src/app/services/http/permission/permission.service';
import { SnackbarService } from 'src/app/services/utils/snackbar/snackbar.service';
import { AsyncValidatorsService } from 'src/app/services';



@Component({
  selector: 'edit-datafield',
  templateUrl: './edit-datafield.component.html',
  styleUrls: ['./edit-datafield.component.scss']
})
export class EditDatafieldComponent implements OnInit {

  verifyUserPermission$: Observable<boolean> = this._permissionService.verify(PermissionsEnum.EDIT_DATASHEET)
  @Input() datafield: Datafield

  @ViewChild('editDatafieldModal') editDatafieldModal: TemplateRef<any>
  modalReference: NgbModalRef

  editDatafieldFormGroup: FormGroup
  datafieldTypes$: Observable<DatafieldTypes>
  formGroupSubmitted: boolean
  editingDatafield: boolean

  @Output() datafieldEdited: Subject<void> = new Subject<void>()

  constructor(
    private _modalService: NgbModal,
    private _formBuilder: FormBuilder,
    private _pepService: PepService,
    private _permissionService: PermissionService,
    private _snackbarService: SnackbarService,
    private _asyncValidators: AsyncValidatorsService,
  ) { }

  ngOnInit(): void {
    if (!this.datafield) {
      throw new Error('O parametro datafield não foi passado para o componente edit-datafield.')
    }
  }

  openModal(): void {
    this.editDatafieldFormGroup = this._formBuilder.group({
      description: [this.datafield.description, [Validators.required], [this._asyncValidators.datafieldDoesntExistInSection(this.datafield.datasheetSessionId, this.datafield._id)]],
      order: [this.datafield.order, [Validators.required]]
    })
    this.datafieldTypes$ = this._pepService.getDatafieldTypes()
    this.formGroupSubmitted = false
    this.editingDatafield = false
    this.modalReference = this._modalService.open(this.editDatafieldModal, { backdrop: 'static' })
  }

  editDatafield(): void {
    this.formGroupSubmitted = true
    if (this.editDatafieldFormGroup.valid && !this.editingDatafield) {
      const datafield: Datafield = {
        _id: this.datafield._id,
        description: this.editDatafieldFormGroup.controls['description'].value,
        order: this.editDatafieldFormGroup.controls['order'].value,
        datasheetSessionId: this.datafield.datasheetSessionId,
      }
      this.editingDatafield = true
      this._pepService.editDatafield(datafield)
        .pipe(
          take(1),
          catchError(error => {
            this._snackbarService.show('Campo não alterado, por favor tente novamente.')
            this.editingDatafield = false
            return of(null)
          }),
        )
        .subscribe((datafieldId: number | null) => {
          if (datafieldId) {
            this.datafieldEdited.next()
            this.modalReference.close()
            this._snackbarService.show('Campo da ficha de prontuário editado.')
          }
        })
    }
  }

  get datafieldDescriptionIsBeingValidated(): boolean {
    return this.editDatafieldFormGroup.controls['description'].pending
  }

  get datafieldDescriptionIsInvalid(): boolean {
    return this.editDatafieldFormGroup.controls['description'].invalid
  }

  get datafieldDescriptionAlreadyExistsInSection(): boolean {
    return this.editDatafieldFormGroup.controls['description'].errors?.['datafieldDoesntExistInSection']
  }

  get datafieldDescriptionWasntInformed(): boolean {
    return this.editDatafieldFormGroup.controls['description'].errors?.['required']
  }

  get datafieldTypeIsInvalid(): boolean {
    return this.editDatafieldFormGroup.controls['type'].invalid
  }

  get datafieldOrderIsInvalid(): boolean {
    return this.editDatafieldFormGroup.controls['order'].invalid
  }
}